import { render } from "./TosPage.vue?vue&type=template&id=6d196f54"
import script from "./TosPage.vue?vue&type=script&lang=js"
export * from "./TosPage.vue?vue&type=script&lang=js"
script.render = render

export default script